import React from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';

import Popup from 'components/Popup';
import FilterItem from 'components/FilterItem';

import Input from 'styled/Input';
import DropdownList from 'styled/DropdownList';

const POSITIVE_REACTIONS = ['Продолжение', 'Давай ещё', 'Ещё', 'Хочу ещё', 'А дальше?', 'Почему?', 'Круто', 'Интересно', 'Детали?', 'Ну-ка, подробней', 'Давай подробнее', 'Подробнее'];
const NEGATIVE_REACTIONS = ['Другая новость', 'Не надо', 'Не нужно', 'Скучно', 'Давай другое', 'Скука', 'Нет', 'Неинтересно', 'Дальше', 'Что ещё есть?'];

class ReactionSelect extends React.PureComponent {
  state = {
    isOpen: false,
  }

  get list() {
    return this.props.isPositive ? POSITIVE_REACTIONS : NEGATIVE_REACTIONS;
  }

  handleInputChange = (e) => {
    this.props.onChange(e.target.value);
  }

  handleFilterItemClick = ({ value }) => {
    this.props.onChange(value);
    this.setState({ isOpen: false });
  }

  handleInputFocus = () => {
    this.setState({ isOpen: true });
  }

  handleOnBackdropClick = () => {
    this.setState({ isOpen: false });
  }

  render() {
    return (
      <React.Fragment>
        <Input
          id={this.props.id}
          value={this.props.value}
          type="text"
          onChange={this.handleInputChange}
          onFocus={this.handleInputFocus}
          placeholder="Выберите реакцию"
          disabled={this.props.disabled}
          autoComplete="off"
        />

        <div style={{ position: 'relative' }}>
          <Popup
            isVisible={this.state.isOpen}
            onClickOnBackdrop={this.handleOnBackdropClick}
            isControlled
          >
            <DropdownList style={{ width: '319px' }}>
              <Scrollbars autoHeight autoHeightMax="225px">
                {this.list.map(reaction => (
                  <FilterItem
                    key={reaction}
                    item={{
                      value: reaction,
                      label: reaction,
                    }}
                    onClick={this.handleFilterItemClick}
                    activeFilter={{
                      value: this.props.value,
                      label: this.props.value,
                    }}
                  />
                ))}
              </Scrollbars>
            </DropdownList>
          </Popup>
        </div>
      </React.Fragment>
    );
  }
}

ReactionSelect.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  isPositive: PropTypes.bool,
  id: PropTypes.string,
};

ReactionSelect.defaultProps = {
  onChange: () => {},
  value: '',
  disabled: false,
  isPositive: false,
  id: undefined,
};

export default ReactionSelect;
